import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
    selector: 'aira-labelled-pills',
    templateUrl: './aira-labelled-pills.component.html',
    styleUrl: './aira-labelled-pills.component.css',
    standalone: false
})
export class AiraLabelledPillsComponent {
  @Input() label = '';
  @Input() data;
  @Input() textPropertyName;
  @Input() onHoverPropertyName;
  @Input() previewOnly: boolean = false;

  pillsToRender: any[] = [];
  leftoverCount: number = 0;
  renderData: any[] = [];
  renderTextPropertyName: string = null;

  ngOnInit() {
    this.rebuildPills();
  }

  ngOnChanges() {
    this.rebuildPills();
  }

  rebuildPills(): void {
    this.renderData = this.previewOnly
      ? magicPreviewDummyData.pillsFactors
      : (this.data || []);
    this.renderTextPropertyName = this.previewOnly ? null : this.textPropertyName;
    this.pillsToRender = [];
    this.leftoverCount = 0;
    this.handlePillsData();
  }

  handlePillsData() {
    if (!this.renderData.length) return;

    if (this.renderData.length <= 4) {
      this.pillsToRender = this.renderData;
      return;
    }

    if (this.renderData.length > 4) {
      this.leftoverCount = this.renderData.length - 4;
      this.pillsToRender = this.renderData.slice(0, 4);
    }
  }

  showAllPills() {
    this.pillsToRender = this.renderData;
    this.leftoverCount = null;
  }
}
